
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/privacy",
      function () {
        return require("private-next-pages/[region]/[lang]/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/privacy"])
      });
    }
  